import React from "react";

const Table = ({
  columns,
  rows,
  emptyText = "No data available.",
  tableClassName = "text-left",
  headCellClassName = "",
  bodyCellClassName = "",
}) => {
  if (!rows || rows.length === 0) {
    return <p className="text-sm text-slate-500">{emptyText}</p>;
  }

  return (
    <div className="overflow-auto">
      <table className={`w-full text-sm ${tableClassName}`}>
        <thead className="text-xs uppercase tracking-wide text-slate-500">
          <tr>
            {columns.map((column) => (
              <th key={column.key} className={`py-2 ${headCellClassName}`}>
                {column.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="text-slate-700">
          {rows.map((row, index) => (
            <tr key={row.id || row.key || index} className="border-t border-slate-100">
              {columns.map((column) => (
                <td key={column.key} className={`py-3 ${bodyCellClassName}`}>
                  {typeof column.render === "function" ? column.render(row) : row[column.key]}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Table;
